import React from "react";
import {DatePicker, Modal, Switch, Typography} from "antd";
import moment from "moment-timezone";

class Dates extends React.Component {

	updateTotal = (partial_payment_sw) => {
        const { from, coverageDays, coveragePrice, coverageProfit, dateRange, extraCoverage } = this.props.state;
        const multiplier = extraCoverage ? 2 : 1;
        let total = 0;
        if (coverageDays > 0) {
            total = (partial_payment_sw  ? coverageProfit : coveragePrice) * multiplier;
        } else if (dateRange) {
            const diff = dateRange[1].diff(dateRange[0], "days", true);
            total = (partial_payment_sw  ? Math.ceil(diff) * coverageProfit : Math.ceil(diff) * coveragePrice) * multiplier;
        }

        this.props.onChange({ total });
    }

	// Re-anchors a picked moment's wall-clock digits into America/Chicago,
	// regardless of the agent's browser/OS timezone. This ensures policy
	// dates are always legally correct Central Time at the source, instead
	// of relying on a downstream "+2 hours" compensation hack.
	toCentral = (m) => moment.tz(m.format("YYYY-MM-DD HH:mm:ss"), "America/Chicago");

	// "Now", but always in Central Time. The date/time constraints below
	// (disabledDate, disabledTime, quick-select ranges) must use this
	// instead of a plain moment() — otherwise an agent whose browser isn't
	// on Central Time can pick something that looks valid on their own
	// clock but lands in the past once toCentral() re-anchors it, causing
	// a false "Date Range Error".
	centralNow = () => moment.tz("America/Chicago");

	dateChanged = (e) => {
		if (this.props.state.coverageDays > 0) {
			const from = this.toCentral(e);
			this.props.onChange({
				from,
				to: from.clone().add(this.props.state.coverageDays, "days"),
				days: this.props.state.coverageDays,
				//total: this.props.state.partial_payment_sw? this.props.state.coverageProfit: this.props.state.coveragePrice,
			});
		} else {
			const from = this.toCentral(e[0]);
			const to = this.toCentral(e[1]);
			const diff = to.diff(from, "days", true);
			this.props.onChange({
				dateRange: [from, to],
				from,
				to,
				days: Math.ceil(diff),
				//total: this.props.state.partial_payment_sw? Math.ceil(diff) * this.props.state.coverageProfit: Math.ceil(diff) * this.props.state.coveragePrice,
			}, () => {
				const insuranceStart = moment(this.props.state.from["toDate"]());
				if (!insuranceStart.isAfter()) {
					Modal.error({
						title: "Date Range Error",
						content: "This date is in the past. Please double check the time.",
					});
				}
			});
		}
		this.updateTotal();


	};

	handleSwitchChange = (e) => {
		const newPartialPaymentSw = e;
        this.props.onChange({ partial_payment_sw: e });
        this.updateTotal(newPartialPaymentSw);
    }
	render() {
		return (
			<>
				<Typography.Title level={4}>Dates Covered*</Typography.Title>
				<div className={"gx-form-group"}>
					{
						this.props.state.coverageDays > 0 ?
							<DatePicker
								showTime={{
									hideDisabledOptions: true,
									//defaultValue: moment().add(2, "hour"),
								}}
								format={"lll"}
								style={{width: "100%"}}
								placeholder="Start date"
								onChange={this.dateChanged}
								disabledDate={current => current < this.centralNow().subtract(1, "day").endOf("day")}
								disabledTime={current => {
									var hours = [];
									for(var i =0; i < this.centralNow().add(1, "h").hour(); i++){
										hours.push(i);
									}
									return {
										disabledHours: () => current.isSame(this.centralNow(),"d") ? hours : []
									}
								}}
								value={this.props.state.from}
							/>
							:
							<DatePicker.RangePicker
								style={{width: "100%"}}
								showTime={{
									hideDisabledOptions: true,
									//defaultValue: [moment().add(2, "hour"), moment().add(2, "hour")],
								}}
								format={"lll"}
								disabledDate={current => current < this.centralNow().subtract(1, "day").endOf("day")}
								disabledTime={(current, type) => {
									if (type === "end" || !current || !current.length) return {};

									var hours = [];
									for(var i =0; i < this.centralNow().add(1, "h").hour(); i++){
										hours.push(i);
									}

									return {
										disabledHours: () => current[0].isSame(this.centralNow(),"d") ? hours : []
									}
								}}
								ranges={{
									"24 Hours": [this.centralNow().add(2, "hour"), this.centralNow().add(25, "hours")],
									"48 Hours": [this.centralNow().add(2, "hour"), this.centralNow().add(49, "hours")],
									"72 Hours": [this.centralNow().add(2, "hour"), this.centralNow().add(73, "hours")],
								}}
								onChange={this.dateChanged}
								value={this.props.state.dateRange}
							/>
					}
				</div>
				{
					this.props.state.partial_payment && (
					<>
						<Typography.Title level={4}>Partial Payment</Typography.Title>
						<Switch checked={this.props.state.partial_payment_sw} onChange={e => this.handleSwitchChange(e) } />
					</>
					)
				}
			</>
		);
	}
}

export default Dates;